export const VARIANT_KEY = 'variant';

export const VARIANT_VALUES = {
  A: 'a',
  B: 'b',
  C: 'c',
  D: 'd',
};

export const SEGMENT_VARIANT = {
  a: 'segment_a',
  b: 'segment_b',
  c: 'segment_c',
  d: 'segment_d',
  e: 'segment_f1',
};



// WEBPACK FOOTER //
// ./constants/variantConstants.ts